module.exports = __webpack_public_path__ + "assets/img/c2624f25ffa1caf0b4aeeb6ac5d570e0.svg";